const products = [
  { value: "VIDA", label: "Seguros de Vida" },
  { value: "PREST", label: "Seguro Prestamista" },
  { value: "PREV", label: "Previdência" },
];

export default products;
